import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class UserVerifiedNotification extends Notification {
  icon() {
    return 'fas fa-certificate';
  }
  href() {
    // subject() devolve um Model genérico; aqui é sempre o User verificado.
    const subject = this.attrs.notification.subject();
    return subject ? app.route.user(subject) : '';
  }
  content() {
    return app.translator.trans('ramon-verified.forum.notifications.user_verified_text');
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('ramon-verified', 'forum/components/UserVerifiedNotification', UserVerifiedNotification);